import React from "react";
import { Form, Modal, Button, Row, Col } from "react-bootstrap";
import { StyleSheet, css } from "aphrodite";
import { callApi, validateToken } from "../../lib/utils";
import TextField from "../GenericComponents/TextField";
import CustomLoader from "../GenericComponents/CustomLoader";
//import styles from "../../../public/"
import styles from "./style";

class ChangeEmailModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            oldEmailId: props.profileData.patientData.email,
            newEmailId: "",
            failureMessage: "",
            successMessage: "",
            loading: false,
            isValidEmail: false,
            emailUpdateCustomModal: false
        };
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        let isValidEmail = false;

        isValidEmail = this.validateEmail(e);

        this.setState({
            [name]: value,
            isValidEmail
        })
    }

    validateEmail = (e) => {
        let isValidEmailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

        let isValidEmail = false;

        if (e.target?.value && e.target.value.match(isValidEmailRegex)) {
            isValidEmail = true;
        } else {
            isValidEmail = false;
        }
        return isValidEmail;
    }

    handleClose = () => {
        this.setState(
            {
                newEmailId: "",
                failureMessage: "",
                successMessage: "",
            },
            () => {
                this.props.close();
            }
        );
    };

    submit = () => {
        let newEmailAddress = this.state.newEmailId;
        if (newEmailAddress.length === 0) {
            this.setState({
                failureMessage: "New Email Address cannot be blank",
            });
        } else if (!this.state.isValidEmail) {
            this.setState({
                failureMessage:
                    "Please enter a valid new email address",
            });
        } else {
            this.setState({
                emailUpdateCustomModal: !this.state.emailUpdateCustomModal
            }, () => {
                this.props.close(false);
            })
        }
    }

    handleEmailUpdateCustomModal = (flag) => {
        if (flag) {
            this.setState({
                emailUpdateCustomModal: !this.state.emailUpdateCustomModal
            }, () => {
                this.updateEmailAddress();
                this.props.close(true);
            })
        }
        else
            this.setState({
                emailUpdateCustomModal: !this.state.emailUpdateCustomModal
            }, () => {
                this.props.close(true);
            })
    }

    updateEmailAddress = () => {
        validateToken((err) => {
            if (err) {
                window.location = "/logout";
            }
            let params = {
                oldEmailAddress: this.state.oldEmailId,
                newEmailAddress: this.state.newEmailId,
            };
            this.setState({
                loading: true,
            });
            callApi(`/api/patient/web/email-change/request`, params, "POST")
                .then((response) => {
                    //console.log("response...", response);
                    if (response.status === 200) {
                        this.setState(
                            {
                                failureMessage: "",
                                loading: false,
                            },
                            () => {
                                this.props.verifyEmailChange(response.data.data.token, this.state.newEmailId);
                            }
                        );
                    } else {
                        this.setState({
                            failureMessage: response.data.message,
                            loading: false,
                        });
                    }
                })
                .catch((err) => {
                    console.log("err: ", err);
                    this.setState({
                        failureMessage: err.message ? err.message : "something went wrong!",
                        loading: false,
                    });
                });
        });
    };

    render() {
        const { show, title, profileData } = this.props;

        return (
            <div>
                <CustomLoader loading={this.state.loading} />
                <Modal
                    size={"md"}
                    show={this.state.emailUpdateCustomModal}
                    centered={true}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header className={css(styles.headerStyle)}>
                        <div className={css(styles.title)}>{"Confirm"}</div>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <div>{"Yor are requesting to change your registered email address.This change will update your username for the user portal to the new email address.Are you sure you want to preoceed with this change?"}</div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className={css(styles.footerStyle)}>
                        <>
                            <Button
                                variant="primary"
                                onClick={() => this.handleEmailUpdateCustomModal(true)}
                            >
                                OK
                            </Button>
                            <Button
                                variant="secondary"
                                onClick={() => this.handleEmailUpdateCustomModal(false)}
                            >
                                CANCEL
                            </Button>
                        </>
                    </Modal.Footer>
                </Modal>
                <Modal
                    size="md"
                    show={show}
                    onHide={() => this.handleClose(false)}
                    centered={true}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton className={css(styles.headerStyle)}>
                        <Modal.Title>
                            <div className={css(styles.title)}>{title}</div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            {this.state.failureMessage && (
                                <div
                                    style={{
                                        backgroundColor: "white",
                                        color: "red",
                                        textAlign: "center",
                                    }}
                                >
                                    {this.state.failureMessage}
                                </div>
                            )}
                            {/* {this.state.successMessage && (
                <div
                  style={{
                    backgroundColor: "white",
                    color: "green",
                    textAlign: "center",
                  }}
                >
                  {this.state.successMessage}
                </div>
              )} */}
                            <p className="pStyle"></p>
                            <Form className="form-horizontal" autoComplete="off">
                                <Form.Group style={{}}>
                                    {/* <img
                                        className={css(style.imageiconsMenu)}
                                        alt="email"
                                        src="/images/header/email_icon.png"
                                    /> */}
                                    <Form.Label className={css(styles.modalLabels)}>
                                        Old Email Address
                                    </Form.Label>
                                    <div style={{ width: "100%" }}>
                                        <TextField
                                            type={"email"}
                                            placeholder={"Old Email Address"}
                                            name={"oldEmailId"}
                                            value={this.state.oldEmailId}
                                            action={this.handleChange}
                                            className="form-control inputstyle"
                                            readOnly={true}
                                        />
                                    </div>
                                </Form.Group>{" "}
                                <br />
                                <Form.Group style={{}}>
                                    {/* <img
                                        className={css(style.imageiconsMenu)}
                                        alt="email"
                                        src="/images/header/email_icon.png"
                                    /> */}
                                    <Form.Label className={css(styles.modalLabels)}>
                                        New Email Address
                                    </Form.Label>
                                    <div style={{ width: "100%" }}>
                                        <TextField
                                            type={"email"}
                                            placeholder={"New Email Address"}
                                            name={"newEmailId"}
                                            value={this.state.newEmailId}
                                            action={this.handleChange}
                                            className="form-control inputstyle"
                                            isInvalid={
                                                !this.state.isValidEmail &&
                                                this.state.newEmailId.length !== 0
                                            }
                                        />
                                    </div>
                                </Form.Group>
                            </Form>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className={css(styles.footerStyle)}>
                        <Button variant="primary" onClick={() => this.submit()}>
                            Update Email
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default ChangeEmailModal;
